import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Section from "./components/Section";
import CardGroup from "./components/CardGroup";
import courses from "./data/courses.json";

const Training = () => (
  <React.Fragment>
    <Helmet>
      <title>Aspiricity - Training Services</title>
    </Helmet>

    <Header>
      <h2>Training</h2>
    </Header>

    <Section bgColor="bg-light" textColor="text-dark">

      <p className="lead">
        Structured learning resources focused on software testing, quality engineering, and practical development skills for modern teams.
      </p>

      <p>
        <span className="badge rounded-pill bg-primary">Updated Curriculum</span>{" "}
        Our training materials are currently being refreshed to reflect modern testing practices, automation approaches, and evolving industry needs.
      </p>

      <p>
        Aspiricity training is designed for individuals and teams looking to build practical, real-world software testing and quality assurance skills. Our content continues to evolve as we expand into modern automation practices and emerging development workflows.
      </p>

      <hr />

      <p className="lead">
        Available Courses
      </p>

      <CardGroup cards={courses} />

      <p>
        We regularly update and expand our training catalogue. Some courses may be temporarily unavailable while we improve and extend their content to ensure alignment with current best practices.
      </p>

      <br />
    </Section>

    <Footer />
  </React.Fragment>
);

export default Training;